module.exports = __webpack_public_path__ + "static/media/11.9b371208.jpg";